import { MergeCompany } from './MergeCompany'

export default MergeCompany
